import { Action, Reducer } from "redux";
import {
	ParameterTypeValueActionTypes,
	ParameterTypeValueState,
	ParameterTypeValueTypes,
} from "./parameterTypeValueTypes";

export const INITIAL_STATE: ParameterTypeValueState = {
	parameterTypeValue: {
		data: false,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const parameterTypeValueReducer: Reducer<ParameterTypeValueState> = (
	state: ParameterTypeValueState = INITIAL_STATE,
	action: Action,
) => {
	const actionTypes = action as ParameterTypeValueActionTypes;
	switch (actionTypes.type) {
		case ParameterTypeValueTypes.UPDATE_CHANGE_FORM:
			return {
				...state,
				parameterTypeValue: {
					...state.parameterTypeValue,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case ParameterTypeValueTypes.RESET_CHANGE_FORM:
			return {
				...state,
				parameterTypeValue: INITIAL_STATE.parameterTypeValue,
			};
		default:
			return state;
	}
};

export default parameterTypeValueReducer;
